import { put, race, select, take } from 'redux-saga/effects';

import ActionTypes from 'containers/Configurator/constants/history';
import {
  makeSelectHistoryIndice,
  makeSelectSteps,
} from 'containers/Configurator/selectors/history';
import { restoreFurnitureStepAction } from 'containers/Configurator/actions/furniture';
import { historyUndoSuccess } from 'containers/Configurator/actions/history';
import {
  addMessageAction,
  flushMessagesAction,
} from 'containers/InteractiveArea/actions';
import { HistoryStep } from 'containers/Configurator/types';

export default function* historySaga() {
  while (true) {
    const winner = yield race({
      undo: take(ActionTypes.HISTORY_UNDO),
      redo: take(ActionTypes.HISTORY_REDO),
    });

    const indiceHistory: number = yield select(makeSelectHistoryIndice());
    const stepsHistory: HistoryStep[] = yield select(makeSelectSteps());

    let restoreStep = undefined;
    if (winner.undo) {
      if (indiceHistory > 0) restoreStep = stepsHistory[indiceHistory - 1];
    } else if (winner.redo) {
      if (indiceHistory < stepsHistory.length - 1)
        restoreStep = stepsHistory[indiceHistory + 1];
    }
    if (restoreStep !== undefined) {
      yield put(restoreFurnitureStepAction(restoreStep));
      if (winner.undo) yield put(historyUndoSuccess(indiceHistory - 1));
      else yield put(historyUndoSuccess(indiceHistory + 1));
      if (restoreStep.message) yield put(addMessageAction(restoreStep.message));
      else yield put(flushMessagesAction());
    }
  }
}
